var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminView',[_c('h1',{staticClass:"title-1"},[_vm._v("Étapes de réglage")]),_c('div',{staticClass:"column"},[_c('SettingsStepsForm',{attrs:{"settingsSteps":_vm.settingsSteps}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }